module.exports = __webpack_public_path__ + "img/course_completion_certificate.b8b253bc.jpg";